// Reconstructed from the supplied production build; original component names were unavailable.
const navLogo = "/NavLogo.webp";
const logo = "/Logo.webp";
const logoIcon = "/LogoIcon.webp";
export { navLogo, logo, logoIcon };
